import getActionsByDocument from '../../../../components/logs/actions';

const DOCUMENT = 'APPLICANT_LOGS_';

export default getActionsByDocument(DOCUMENT);
